import React, { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';

import TitleBar from '../../titleBar/titleBar';
import AgGridTable from '../../agGridComponent/agGridTable';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder'


import { getConsignor, updateConsignor, deleteConsignor } from '../../../redux/actions/consignorMasterActions ';
import ConsignorActionButton from './consignorActionButton';
import { FEATURES } from '../../utils/constants';

function ConsignorTable(props) {

    const { consignorData, consignorLoading, getConsignor, updateConsignor, deleteConsignor } = props;

    useEffect(() => {
        getConsignor()
    }, [getConsignor]);


    if (consignorLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Consignor" LinkName="" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = [
            { headerName: 'Consignor Code', field: 'consignorCode', tooltipField: 'consignorCode', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Consignor Name', field: 'consignorName', tooltipField: 'consignorName', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'City', field: 'city', tooltipField: 'city', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Consignor Address', field: 'consignorAddress', tooltipField: 'consignorAddress', width: 300, suppressToolPanel: true, enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated By', field: 'updatedBy', tooltipField: 'updatedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated On', field: 'updateOn', tooltipField: 'updateOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true }
        ]

        let frameworkComponents = {
            actionRenderer: ConsignorActionButton,
        }

        let rowData = []

        consignorData && consignorData.forEach((object, index) => {
            let temp = {}
            temp.consignorCode = object.consignorCode
            temp.consignorName = object.consignorName
            temp.consignorId = object.consignorId
            temp.city = object.cityName
            temp.consignorAddress = object.address
            temp.createdBy = object.createdBy
            temp.createdOn = object.createdOn
            temp.updatedBy = object.updatedBy
            temp.updatedOn = object.updatedOn
            temp.updateConsignor = updateConsignor
            temp.deleteConsignor = deleteConsignor
            rowData[index] = temp
        })


        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    link="/add-consignor"
                    baseURL={props}
                    //hiddenNewPopupBtn={true}
                    newPopup={props.newPopup}
                    hiddenImportPopupBtn={false}
                    pathName='consignorMaster'
                    fileName='consignorMaster'
                    extraComponents={frameworkComponents}
                    titleBarTitle="Consignor"
                    handleSearch={props.handleSearch}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    consignorData: state.getConsignorData.consignor.resultSet,
    consignorLoading: state.getConsignorData.isLoading
})

export default connect(mapStatetoProps, { getConsignor, updateConsignor, deleteConsignor })(ConsignorTable)